import { gql } from '@apollo/client';

export const GET_LOST_ANIMALS = gql`
  query GetLostAnimals($userLocation: [Float!]!, $radiusInKm: Float!) {
    getLostAnimals(userLocation: $userLocation, radiusInKm: $radiusInKm) {
      _id
      userId
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateLost
      sex
      lastSeen
      estimatedWeight
      approachable
      rewardAmount
      createdAt
      updatedAt
      reunited
    }
  }
`;

export const GET_LOST_ANIMAL = gql`
  query GetLostAnimal($_id: ID!) {
    getLostAnimal(_id: $_id) {
      _id
      userId
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateLost
      sex
      lastSeen
      estimatedWeight
      approachable
      rewardAmount
      createdAt
      updatedAt
      reunited
      language
      expiresAt
      extensionCount
      lastExtendedAt
    }
  }
`;